export default interface Company {
  id: number;
  companyName?: string;
  logo?: string;
  licenses?: CompanyLicense[];
}

export interface CompanyLicense {
  productId: number;
  productName: string;
  licensed: boolean;
}

export interface CompanySettings {
  companyName: string;
  reportLogo?: {
    url: string;
  };
}

export enum Applications {
  Admin = 1,
  Detector,
  Gmd,
  Responder,
  Investigator,
}
